import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { Formik, Form, FormikHelpers } from 'formik';
import { isUndefined } from 'lodash';

import { StepperFormBodyProps, useStepperForm, useStepperFormBody } from '@components/Base';

import { ContactStepForm } from './contact-step-form';
import QuestionStepForm from './QuestionStepForm';
import { useSteps } from './hook';
import { FormValues } from './type';

const FormForm = ({ steps, questions, description }: StepperFormBodyProps & { questions: { question: string }[]; description: string }) => {
  const { handleNext, handlePrev } = useStepperFormBody(steps);

  return (
    <Form>
      <Routes>
        <Route index element={<ContactStepForm onNext={handleNext} />} />
        <Route path="contact" element={<ContactStepForm onNext={handleNext} />} />
        <Route path="question" element={<QuestionStepForm onPrev={handlePrev} onNext={handleNext} questions={questions} description={description} />} />
        <Route path="*" element={<Navigate to="" />} />
      </Routes>
    </Form>
  );
};

type Props = {
  initialValues: FormValues;
  onSubmit: (values: FormValues) => void;
  questions: { question: string }[];
  description: string;
};

const HealthQuoteBuyForm = ({ initialValues, onSubmit, questions, description }: Props) => {
  const steps = useSteps(questions);
  const { activeStepIdx, isLastStep, next } = useStepperForm(steps);

  const handleSubmit = (values: FormValues, { setSubmitting }: FormikHelpers<FormValues>) => {
    setSubmitting(false);
    isLastStep ? onSubmit(values) : next(values);
  };

  if (isUndefined(steps)) return null;

  return (
    <Formik
      initialValues={initialValues}
      validationSchema={steps[activeStepIdx].validationSchema}
      onSubmit={handleSubmit}
    >
      <FormForm steps={steps} questions={questions} description={description} />
    </Formik>
  );
};

export { HealthQuoteBuyForm };
